import { useQuery } from 'react-query';
import request from '../../../../helpers/request';

const key = ['transportCountries'];

const getTransportCountries = async () => {
  return await request.get(
    '/HousingStock/transport/country',
    {},
    'При загрузке стран произошла ошибка',
    []
  );
};

const useTransportCountries = (options = {}) =>
  useQuery(key, getTransportCountries, options);

export default useTransportCountries;
